webpackJsonp([4],{

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Action;
(function (Action) {
    Action[Action["UpdateFilters"] = 0] = "UpdateFilters";
})(Action || (Action = {}));
var TimetableFilters = /** @class */ (function (_super) {
    __extends(TimetableFilters, _super);
    function TimetableFilters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimetableFilters.prototype.mounted = function () {
    };
    Object.defineProperty(TimetableFilters.prototype, "shouldShowGroupLevels", {
        get: function () {
            if (!this.groupType) {
                return false;
            }
            var index = this.showGroupLevelsWith.indexOf(this.groupType.toLowerCase());
            return index > -1;
        },
        enumerable: true,
        configurable: true
    });
    TimetableFilters.prototype.updateFilters = function () {
        var component = this;
        var data = {
            groupLevel: component.groupLevel,
            groupTypeId: component.groupType,
            trainerId: component.trainer,
            locationId: component.location
        };
        __WEBPACK_IMPORTED_MODULE_2__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_1__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.UpdateFilters]), { dataType: "json", method: "post", data: data })
            .done(function (res) {
            if (!res) {
                return;
            }
            if (!component.location) {
                component.$emit('update:locations', res.locations);
                //component.locations = res.locations;
            }
            if (!component.groupLevel) {
                component.$emit('update:groupLevels', res.groupLevels);
                //component.groupLevels = res.groupLevels;
            }
            if (!component.groupType) {
                component.$emit('update:groupTypes', res.groupTypes);
                //component.groupTypes = res.groupTypes;
            }
            if (!component.trainer) {
                component.$emit('update:trainers', res.trainers);
                //component.trainers = res.trainers;
            }
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "groupLevels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "groupTypes", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "trainers", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "locations", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "showGroupLevelsWith", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "groupType", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "groupLevel", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "trainer", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], TimetableFilters.prototype, "location", void 0);
    TimetableFilters = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], TimetableFilters);
    return TimetableFilters;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (TimetableFilters);


/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TrainingGroup_RegisterView__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrainingGroup_TimeTableView__ = __webpack_require__(504);



__WEBPACK_IMPORTED_MODULE_0__Core_Factories_ViewFactory__["a" /* ViewFactory */].setRegistry({
    'RegisterView': __WEBPACK_IMPORTED_MODULE_1__TrainingGroup_RegisterView__["a" /* RegisterView */],
    'TimeTableView': __WEBPACK_IMPORTED_MODULE_2__TrainingGroup_TimeTableView__["a" /* TimeTableView */]
});


/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegisterView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Action;
(function (Action) {
    Action[Action["GetGroupMembers"] = 0] = "GetGroupMembers";
    Action[Action["ChangeTrainingGroup"] = 1] = "ChangeTrainingGroup";
})(Action || (Action = {}));
var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
        this.children = new Array();
        this.payers = new Array();
        this.trainingGroups = new Array();
        this.defaultSchedules = new Array();
    }
    return ViewDataModel;
}());
var RegisterView = /** @class */ (function (_super) {
    __extends(RegisterView, _super);
    function RegisterView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    RegisterView.prototype.SetupVue = function () {
        var _data = {
            selectedChildId: this._viewData.selectedChildId,
            selectedPayerId: this._viewData.selectedPayerId,
            anotherPayer: this._viewData.anotherPayer,
            attendeeEInvoice: this._viewData.attendeeEInvoice,
            registrantEInvoice: this._viewData.registrantEInvoice,
            payerEInvoice: this._viewData.payerEInvoice,
            registeredResidenceId: this._viewData.registeredResidenceId,
            otherRegisteredResidenceId: this._viewData.otherRegisteredResidenceId,
            isCompany: true,
            children: this._viewData.children,
            payers: this._viewData.payers,
            trainingGroups: this._viewData.trainingGroups,
            defaultSchedules: this._viewData.defaultSchedules,
            changeGroup: this._viewData.changeGroup
        };
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".app",
            data: _data,
            mounted: function () {
                //this.updateGroupMembers();
            },
            computed: {
                selectedChild: function () {
                    if (!_data.selectedChildId) {
                        return {};
                    }
                    return _data.children.find(function (x) { return x.id === _data.selectedChildId; });
                },
                selectedPayer: function () {
                    if (!_data.selectedPayerId) {
                        return {};
                    }
                    return _data.payers.find(function (x) { return x.id === _data.selectedPayerId; });
                },
            },
            methods: {}
        });
        //function prepareGroupMembers(groupMembers: Array<IClient>): Array<IClient> {
        //    groupMembers.forEach(x => {
        //        x.cancelContract = false;
        //        x.changeGroup = false;
        //        x.newGroupId = "";
        //        x.validationResults = {};
        //    });
        //    return groupMembers;
        //}
    };
    return RegisterView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeTableView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Core_Helpers_Uri__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__brightspark_sparkling_ajax_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__brightspark_sparkling_ajax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__brightspark_sparkling_ajax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_TimetableFilters_TimetableFilters_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Xelect_XelectComponent_vue__ = __webpack_require__(75);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var Action;
(function (Action) {
    Action[Action["GetTimetableFilters"] = 0] = "GetTimetableFilters";
    Action[Action["GetTimetableItems"] = 1] = "GetTimetableItems";
})(Action || (Action = {}));
var ViewDataModel = /** @class */ (function () {
    function ViewDataModel() {
        this.showGroupLevelsWith = [];
        this.groupType = "";
        this.groupLevel = "";
        this.trainer = "";
        this.location = "";
    }
    return ViewDataModel;
}());
var TimeTableView = /** @class */ (function (_super) {
    __extends(TimeTableView, _super);
    function TimeTableView() {
        var _this = _super.call(this) || this;
        _this._viewData = window.__VIEW_DATA;
        _this.SetupVue();
        return _this;
    }
    TimeTableView.prototype.SetupVue = function () {
        var v = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
            el: ".timetable-filters",
            data: {
                showGroupLevelsWith: this._viewData.showGroupLevelsWith,
                groupLevels: new Array(),
                groupTypes: new Array(),
                trainers: new Array(),
                locations: new Array(),
                trainingGroups: new Array(),
                groupType: this._viewData.groupType,
                groupLevel: this._viewData.groupLevel,
                trainer: this._viewData.trainer,
                location: this._viewData.location,
                isTableItemsLoading: false
            },
            mounted: function () {
                this.filterChange();
            },
            components: {
                TimetableFilters: __WEBPACK_IMPORTED_MODULE_4__Components_TimetableFilters_TimetableFilters_vue__["a" /* default */],
                XelectComponent: __WEBPACK_IMPORTED_MODULE_5__Components_Xelect_XelectComponent_vue__["a" /* default */]
            },
            computed: {
                shouldShowGroupLevels: function () {
                    var vue = this;
                    var index = vue.showGroupLevelsWith.indexOf(vue.groupType.toLowerCase());
                    return index > -1;
                },
                isTableEmpty: function () {
                    var vue = this;
                    return !vue.trainingGroups.length && !vue.isTableItemsLoading;
                }
            },
            methods: {
                shouldShowExactNumber: function (trainingGroup) {
                    return trainingGroup.freePlaces <= 5;
                },
                getFreePlaceText: function (trainingGroup) {
                    return this.shouldShowExactNumber(trainingGroup)
                        ? trainingGroup.freePlaces === 1 ? "koht jäänud!" : "viimast kohta!"
                        : "kohta veel vaba!";
                },
                getWaitlistMemberText: function (trainingGroup) {
                    return trainingGroup.waitlistMemberCount > 1 || trainingGroup.waitlistMemberCount === 0
                        ? "inimest ootel"
                        : "inimene ootel";
                },
                filterChange: function () {
                    var vue = this;
                    __WEBPACK_IMPORTED_MODULE_3__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_2__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.GetTimetableFilters]), { dataType: "json", method: "post", data: vue.getSelectedFilters() })
                        .done(function (res) {
                        if (!res) {
                            return;
                        }
                        vue.locations = res.locations;
                        vue.groupLevels = res.groupLevels;
                        vue.groupTypes = res.groupTypes;
                        vue.trainers = res.trainers;
                    });
                    vue.getTimeTableItems();
                },
                getTimeTableItems: function () {
                    var vue = this;
                    vue.isTableItemsLoading = true;
                    __WEBPACK_IMPORTED_MODULE_3__brightspark_sparkling_ajax_js__(__WEBPACK_IMPORTED_MODULE_2__Core_Helpers_Uri__["a" /* Uri */].getUri(Action[Action.GetTimetableItems]), { dataType: "json", method: "post", data: vue.getSelectedFilters() })
                        .done(function (res) {
                        if (!res) {
                            return;
                        }
                        vue.trainingGroups = res;
                    })
                        .always(function () {
                        vue.isTableItemsLoading = false;
                    });
                },
                getSelectedFilters: function () {
                    return {
                        groupLevel: this.groupLevel,
                        groupTypeId: this.groupType,
                        trainerId: this.trainer,
                        locationId: this.location
                    };
                },
                valueChanged: function (value, component) {
                    var name = component.name;
                    var vue = this;
                    if (vue[name] === value) {
                        return;
                    }
                    switch (name) {
                        case "LocationId":
                            vue.location = value;
                            break;
                        case "TrainerId":
                            vue.trainer = value;
                            break;
                        case "GroupTypeId":
                            vue.groupType = value;
                            break;
                        case "GroupLevel":
                            vue.groupLevel = value;
                            break;
                        default:
                            return;
                    }
                    vue.filterChange();
                },
            }
        });
    };
    return TimeTableView;
}(__WEBPACK_IMPORTED_MODULE_0__Core__["b" /* View */]));



/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_TimetableFilters_ts__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117b83c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimetableFilters_vue__ = __webpack_require__(506);
var disposed = false
var normalizeComponent = __webpack_require__(27)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_TimetableFilters_ts__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117b83c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimetableFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "www\\js\\Components\\TimetableFilters\\TimetableFilters.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-117b83c6", Component.options)
  } else {
    hotAPI.reload("data-v-117b83c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("default", null, {
        groupLevels: _vm.groupLevels,
        groupTypes: _vm.groupTypes,
        trainers: _vm.trainers,
        locations: _vm.locations,
        groupType: _vm.groupType,
        groupLevel: _vm.groupLevel,
        trainer: _vm.trainer,
        location: _vm.location,
        shouldShowGroupLevels: _vm.shouldShowGroupLevels,
        filterChanged: _vm.updateFilters
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-117b83c6", esExports)
  }
}

/***/ })

},[502]);


// WEBPACK FOOTER //
// js/page/trainingGroup.bundle.js